/* eslint-disable no-undef */
/* eslint-disable object-shorthand */
import { client } from './client';

export const list = () => client.get('recharges');
export const providers = () => client.get('recharge/providers');
export const products = params => client.get('recharge/products', { params: { recharge: params } });
export const recharge = params => client.post('recharge', { recharge: params });
export const show = id => client.get(`recharges/${id}`);
export const confirm = id => client.post(`recharge/${id}/capture`);
export const cancel = id => client.delete(`recharges/${id}`);
